import * as React from 'react';

import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

import BaseIcon from '../BaseIcon';

const Bitrix24Icon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{
        viewBox: '0 0 24 24'
      }}
      {...props}
    >
      <path
        fill="#2fc7f7"
        d="M18.11 10.95a3.68 3.68 0 0 1 3.39 3.81 3.68 3.68 0 0 1-3.68 3.54H6.43a3.83 3.83 0 0 1-3.12-6.07 3.83 3.83 0 0 1 2.29-1.51 4.11 4.11 0 0 1 7.66-2.74 3.28 3.28 0 0 1 4.85 3.01v-.04z"
      />
      <circle fill="#fff" cx="12" cy="12.94" r="3.6" />
      <path fill="#2fc7f7" d="M11.5 11.19h1v2.28h2.03v1H11.5z" />
    </BaseIcon>
  );
};

export default Bitrix24Icon;
